import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import light from '@/plugins/themes/light'
import icons from '@/plugins/icons'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: { light },
  },
  icons: {
    // iconfont: 'fa',
    values: icons,
  },
})
